<template lang="html">
  <v-container grid-list-md mt-1>
    <ComponentPlantKnowledge />
  </v-container>
</template>


<script>
import ComponentPlantKnowledge from '@/components/ComponentPlantKnowledge'
export default {
  components: {
    ComponentPlantKnowledge
  }
}
</script>

<style lang="css">
</style>
